import { render, staticRenderFns } from "./IconoInformacion.vue?vue&type=template&id=6172ab2c&scoped=true"
import script from "./IconoInformacion.vue?vue&type=script&lang=js"
export * from "./IconoInformacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172ab2c",
  null
  
)

export default component.exports